import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FiArrowLeft } from "react-icons/fi";
import * as Yup from "yup";
import Card from "../Base/Card";
import BaseDatePicker from "../Base/BaseDatePicker";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  getAllPFA,
  transferRSA,
} from "../../redux/selfService/selfServiceSlice";
import LoadingSpinner from "../LoadingSpinner";
import { getStates } from "../../redux/utils/utilsSlice";
import { object, string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorViewer from "../ErrorViewer";
import Required from "../Required";
import EmployerSelect from "../EmployerSelect";
import { RSATransferType } from "../../constants";

interface PropsI {
  isTransfer?: boolean;
  onClose: () => void;
  onTransferSuccess?: () => void;
}

const RSAForm = ({ isTransfer, onClose, onTransferSuccess }: PropsI) => {
  const dispatch = useAppDispatch();
  const { isLoading, allPFA } = useAppSelector((state) => state?.selfService);
  const { allStates } = useAppSelector((state) => state?.utils);
  const { user } = useAppSelector((state) => state?.auth);

  const validationSchema = Yup.object().shape({
    userType: string().required("Please select transfer type"),
    // transferType: string().when("userType", {
    //   is: "1",
    //   then: () => Yup.string().required("Please select a transfer type"),
    // }),
    surname: string().required("Surname is required"),
    firstname: string().required("Firstname is required"),
    othernames: string(),
    remarks: string(),
    address: string().required("Address is required"),
    // oldPfa: string().required("OldPFA is required"),

    oldPfa: string().when("userType", {
        is: "1",
        then: () => Yup.string().required("Old PFA is required"),
        otherwise: () => Yup.string(), // No validation when New User is selected
      }),

    mobilePhone: string().required("Mobile Phone is required"),
    emailAddress: string()
      .required("Email is required")
      .email("Not a valid email"),
    employerName: string().when("userType", {
      is: "1",
      then: () => Yup.string().required("Employer is required"),
      otherwise: () => Yup.string(), // No validation when New User is selected
    }),
    recaptureStatus: string().when("userType", {
      is: "1",
      then: () => Yup.string().required("Please select Recapture status"),
      otherwise: () => Yup.string(), // otherwise: Yup.string(), // No validation when New User is selected
    }),
    stateCode: string().required("Please select a state"),
    dob: string().required("Please select your date of birth"),
    // pin: string().required("Please enter PIN"),
    pin: string().when("userType", {
        is: "1",
        then: () => Yup.string().required("Please enter PIN"),
        otherwise: () => Yup.string(), // No validation when New User is selected
      }),

    nin: string()
    //   .required("Please enter your NIN")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
  });

  const initialValues = {
    // transferType: "",
    userType: "",
    surname: "",
    firstname: "",
    address: "",
    othernames: "",
    oldPfa: undefined,
    mobilePhone: "",
    emailAddress: "",
    employerId: "",
    employerName: "",
    recaptureStatus: "",
    remarks: "",
    dob: "",
    stateCode: "",
    nin: "",
    pin: "",
  };

  const {
    handleSubmit,
    register,
    setValue,
    reset,
    formState: { errors },
    watch,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { ...initialValues },
  });

  useEffect(() => {
    dispatch(getAllPFA());
    dispatch(getStates());
  }, []);

  const onSubmit = async (inputed: any, e: any) => {
    console.log("Submit button clicked for New User");
    e.preventDefault();
    console.log("Submit button clicked for New User 2");
    const data = {
      ...inputed,
      dob: new Date(inputed.dob).toISOString(),
      rsabalance: user.contibutionBalance,
      staffId:undefined,
      transferType: inputed.userType
    //   pin: user.pin,
    };
    dispatch(transferRSA(data)).then((res: any) => {

        console.log('rsa transfer',res);
      if (
        res.type === "selfService/transferRSA/fulfilled" &&
        res.payload.statusCode === "00"
      ) {
        reset({ ...initialValues });
        if (onTransferSuccess) {
          onTransferSuccess();
        }
        onClose();
      }
    });
  };

  return (
    <div className="rsa_form_component">
      <button className="btn btn-outline mb-6" onClick={onClose}>
        <FiArrowLeft /> Back
      </button>
      <Card>
        <div className="h1 text-grayscaleBody">
          {!isTransfer ? "Register New Friend" : "Refer and Reward"}
        </div>
        <Card className="mb-6">
          <div className="section-card">
            <div className="section-card-head">Personal Information</div>
            <div className="w-full">
              <div className="form">
                <div className="form__row">
                  <div className="form__group">
                    <label htmlFor="userType" className="form__label">
                      Transfer Type <Required />
                    </label>
                    <select
                      id="userType"
                      defaultValue=""
                      className="form__select"
                      {...register("userType")}
                    >
                      <option value="" disabled>
                        Select Transfer Type
                      </option>
                      <option value="0">New User</option>
                      <option value="1">Existing User</option>
                    </select>
                    {errors.userType && (
                      <ErrorViewer
                        message={errors.userType.message as string}
                      />
                    )}
                  </div>

                  {/* {
                //   watch("userType") === "1"
                false
                   && ( <div className="form__group">
                    <label htmlFor="transferType" className="form__label">
                      Transfer Type <Required />
                    </label>
                    <select
                      id="transferType"
                      defaultValue=""
                      className="form__select"
                      {...register("transferType", {
                        required: watch("userType") === "1",
                      })}
                    >
                      <option value="" disabled>
                        Select Transfer Type
                      </option>
                      {RSATransferType &&
                        RSATransferType.map((transferType, index: number) => (
                          <option value={transferType.value} key={index}>
                            {transferType.label}
                          </option>
                        ))}
                    </select>
                    {errors.transferType && (
                      <ErrorViewer
                        message={errors.transferType.message as string}
                      />
                    )}
                  </div>
)} */}
                </div>
                <div className="form__row">
                  <div className="form__group">
                    <label htmlFor="surname" className="form__label">
                      Surname <Required />
                    </label>
                    <input
                      id="surname"
                      type="text"
                      className="form__input"
                      placeholder="Surname"
                      {...register("surname", {
                        required: watch("userType") === "1",
                      })}
                    />
                    {errors.surname && (
                      <ErrorViewer message={errors.surname.message as string} />
                    )}
                  </div>
                  <div className="form__group">
                    <label htmlFor="firstname" className="form__label">
                      First Name <Required />
                    </label>
                    <input
                      id="firstname"
                      type="text"
                      className="form__input"
                      placeholder="First Name"
                      {...register("firstname", {
                        required: watch("userType") === "1",
                      })}
                    />
                    {errors.firstname && (
                      <ErrorViewer
                        message={errors.firstname.message as string}
                      />
                    )}
                  </div>
                </div>
                {/* Add other fields for personal information */}

                <div className="form__row">
                  <div className="form__group">
                    <label htmlFor="otherNames" className="form__label">
                      Other Names
                    </label>
                    <input
                      id="otherNames"
                      type="text"
                      className="form__input"
                      placeholder="Other Names"
                      {...register("othernames")}
                    />
                  </div>

                  <div className="form__group">
                    <label htmlFor="address" className="form__label">
                      Address
                    </label>
                    <input
                      id="address"
                      type="text"
                      className="form__input"
                      placeholder="Address"
                      {...register("address")}
                    />
                    {errors.address && (
                      <ErrorViewer message={errors.address.message as string} />
                    )}
                  </div>
                </div>
                <div className="form__row">
                  <div className="form__group">
                    <label htmlFor="date-of-birth" className="form__label">
                      Date of Birth
                    </label>
                    <BaseDatePicker
                      id="date-of-birth"
                      // @ts-ignore
                      onChange={(date) => setValue("dob", date)}
                    />
                    {errors.dob && (
                      <ErrorViewer message={errors.dob.message as string} />
                    )}
                  </div>
                  <div className="form__group">
                    <label htmlFor="mobile-phone" className="form__label">
                      First Mobile Phone <Required />
                    </label>
                    <input
                      id="mobile-phone"
                      type="text"
                      className="form__input"
                      placeholder="Mobile Phone"
                      {...register("mobilePhone")}
                    />
                    {errors.mobilePhone && (
                      <ErrorViewer
                        message={errors.mobilePhone.message as string}
                      />
                    )}
                  </div>
                </div>
                <div className="form__row">
                  <div className="form__group">
                    <label htmlFor="emailAddress" className="form__label">
                      Email Address <Required />
                    </label>
                    <input
                      id="emailAddress"
                      type="email"
                      className="form__input"
                      placeholder="Email Address"
                      {...register("emailAddress")}
                    />
                    {errors.emailAddress && (
                      <ErrorViewer
                        message={errors.emailAddress.message as string}
                      />
                    )}
                  </div>
                  <div className="form__group">
                    <label htmlFor="nin" className="form__label">
                      NIN <Required />
                    </label>
                    <input
                      id="nin"
                      type="number"
                      className="form__input"
                      placeholder="NIN"
                      {...register("nin")}
                    />
                    {errors.nin && (
                      <ErrorViewer message={errors.nin.message as string} />
                    )}
                  </div>
                </div>

                <div className="form__row">
                <div className="form__group">
                      <label htmlFor="state" className="form__label">
                        Location <Required />
                      </label>
                      <select
                        id="state"
                        defaultValue=""
                        className="form__select"
                        {...register("stateCode")}
                      >
                        <option value="" disabled>
                          Select Location
                        </option>
                        {allStates &&
                          Object.keys(allStates).map((a, index) => (
                            <option value={a} key={index}>
                              {allStates[a]}
                            </option>
                          ))}
                      </select>
                      {errors.stateCode && (
                        <ErrorViewer
                          message={errors.stateCode.message as string}
                        />
                      )}
                    </div>
                </div>
              </div>
            </div>
          </div>
        </Card>

        {watch("userType") === "1" && (
          <Card className="mb-6">
            <div className="section-card">
              <div>Employer Information</div>
              <div className="w-full">
                <div className="form">
                  <div className="form__row">
                    <div className="form__group">
                      <label htmlFor="employerID" className="form__label">
                        Employer <Required />
                      </label>
                      <EmployerSelect
                        onChange={(val) => {
                          // @ts-ignore
                          setValue("employerId", val.value.id);
                          setValue("employerName", val.value.txtemployername);
                        }}
                      />

{/* <EmployerSelect
                defaultValue={
                  false
                    ? {
                        value: selectedEmployer as any,
                        label: selectedEmployerName, // Set the selected employer name
                      }
                    : {
                      value: employer.employerId,
                      label: employer.employerName,
                    }
                }
                onChange={(val) => {
                  setSelectedEmployer(val.value.id);
                  setSelectedEmployerName(val.value.txtemployername); // Update selected employer name
                  setValue("employerId", val.value.id);
                }}
              /> */}
                      {errors.employerName && (
                        <ErrorViewer
                          message={errors.employerName.message as string}
                        />
                      )}
                    </div>
                    <div className="form__group">
                      <label htmlFor="resident-pfa" className="form__label">
                        Resident PFA <Required />
                      </label>
                      <select
                        id="resident-pfa"
                        defaultValue=""
                        className="form__select"
                        {...register("oldPfa")}
                      >
                        <option value="" disabled>
                          Select Resident PFA
                        </option>
                        {allPFA &&
                          allPFA.map((pfa: any, index: number) => (
                            <option value={pfa.id} key={index}>
                              {pfa.pfaname}
                            </option>
                          ))}
                      </select>
                      {errors.oldPfa && (
                        <ErrorViewer
                          message={errors.oldPfa.message as string}
                        />
                      )}
                    </div>
                  </div>
                  <div className="form__row">
                   
                    <div className="form__group">
                      <label htmlFor="recapture-status" className="form__label">
                        Select Recapture Status <Required />
                      </label>
                      <select
                        id="recapture-status"
                        defaultValue=""
                        className="form__select"
                        {...register("recaptureStatus")}
                      >
                        <option value="" disabled>
                          Select Recapture Status
                        </option>
                        <option value={7}>Recaptured</option>
                        <option value={0}>Not Recaptured</option>
                      </select>
                      {errors.recaptureStatus && (
                        <ErrorViewer
                          message={errors.recaptureStatus.message as string}
                        />
                      )}
                    </div>
                    <div className="form__group">
                      <label htmlFor="pin" className="form__label">
                        Pin <Required />
                      </label>
                      <input
                        id="pin"
                        type="number"
                        className="form__input"
                        placeholder="PIN"
                        {...register("pin")}
                      />
                      {errors.nin && (
                        <ErrorViewer message={errors.nin.message as string} />
                      )}
                    </div>
                  </div>

                  <div className="form__row">
                  
                  </div>
                </div>
              </div>
            </div>
          </Card>
        )}

        <Card className="mb-6">
          <div className="section-card">
            <div>Additional Information</div>
            <div className="w-full">
              <div className="form">
                <div className="form__group">
                  <label htmlFor="lastName" className="form__label">
                    Remarks (optional)
                  </label>
                  <textarea
                    className="form__input"
                    rows={5}
                    placeholder="Enter other necessary information"
                    {...register("remarks")}
                  />
                </div>
              </div>
            </div>
          </div>
        </Card>
        <div className="flex justify-end mt-8 mb-12">
          <button
            className="btn btn-primary btn-b ml-3"
            onClick={handleSubmit(onSubmit)}
            disabled={isLoading}
          >
            {isLoading ? <LoadingSpinner /> : "Submit"}
          </button>
        </div>
      </Card>
    </div>
  );
};

export default RSAForm;
